var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';
var CheckboxGroupContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > :not([hidden]) ~ :not([hidden]) {\n    margin-top: ", ";\n  }\n"])), selectTheme('checkbox.group.marginBetweenItems'));
export { CheckboxGroupContainer };
//# sourceMappingURL=CheckboxGroup.style.js.map